import { Anchor, Button } from "@newsela/angelou";

import {
  cardCss,
  titleCss,
  subtitleCss,
  linksContainerCss,
  pdfCardCss,
} from "./ResourceCard.style";

interface ResourceCardProps {
  /**
   * The larger text that is visible in the card
   */
  title: string;

  /**
   * Optional small text to display in the second line after the title
   */
  subtitle?: string | undefined;

  /**
   * When set, the card displays an anchor to navigate to an external resource
   */
  href?: string | undefined;

  /**
   * The link text, defaults to "Open resource"
   */
  anchorLabel?: string | undefined;

  /**
   * This link is provided for some resources with a secondary action
   */
  alternativeHref?: string | undefined;

  /**
   * This link text is provided for some resources with a secondary action
   */
  alternativeHrefLabel?: string | undefined;

  /**
   * Applies styles specifc for rendering for PDF output.
   */
  isPDFOutput?: boolean | undefined;
}

const ResourceCard = (props: ResourceCardProps) => {
  const DEFAULT_ANCHOR_LABEL = "Open resource";
  const {
    title,
    subtitle,
    href,
    anchorLabel = DEFAULT_ANCHOR_LABEL,
    alternativeHref,
    alternativeHrefLabel = DEFAULT_ANCHOR_LABEL,
    isPDFOutput,
  } = props;
  return (
    <div css={[cardCss, isPDFOutput && pdfCardCss]}>
      <h2 css={titleCss}>{title}</h2>
      {subtitle && <div css={subtitleCss}>{subtitle}</div>}
      <div css={linksContainerCss}>
        {href && (
          <Anchor
            openInNewTab
            href={href}
            styleAnchorAsButton={{
              flavor: Button.flavors.secondary,
              size: Button.sizes.md,
            }}
          >
            {anchorLabel}
          </Anchor>
        )}
        {alternativeHref && (
          <Anchor
            href={alternativeHref}
            styleAnchorAsButton={{
              flavor: Button.flavors.secondary,
              size: Button.sizes.md,
            }}
          >
            {alternativeHrefLabel}
          </Anchor>
        )}
      </div>
    </div>
  );
};

export default ResourceCard;
